import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractClauseTypeService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cm/contractClauseTypes')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-file-contract';
    }

    getObjectLabels(): string[] {
        return ['partnerDtoName', 'componentKey', 'name'];
    }

}
